jQuery(document).ready(function($) {

    var $nav = $("nav.menu")
    var $burger = $nav.find('label[for="open_menu_mobile"]')

    // même seuil que le media('<medium-plus-screen') du scss
    var mobile = window.matchMedia("(max-width: 1023.98px)")

    //navigation
    $('nav.menu #open_menu_mobile ').on('click', function (event) {

        if( $("nav.menu").hasClass("isActive") ){
            $("nav.menu").removeClass("isActive")
            $("nav.menu .sections .section1").removeClass("isActive")
            $("nav.menu .sections .section2").removeClass("isActive")
            $("nav.menu .sections .section3").removeClass("isActive")
            $("nav.menu .sections .section2 .active").removeClass("active")
            $("html").removeClass("menu-ouvert")
            $burger.attr({"aria-expanded": "false", "aria-label": "Ouvrir le menu"})
        }else{
            $("nav.menu").addClass("isActive")
            $("nav.menu .sections .section1").addClass("isActive")
            $("html").addClass("menu-ouvert")
            $burger.attr({"aria-expanded": "true", "aria-label": "Fermer le menu"})
        }
    })

    $('nav.menu .fond').on('click', function (event) {
        $('nav.menu #open_menu_mobile ').trigger("click")
    })

    // le label fait office de bouton : accessible au clavier
    $burger.on('keydown', function (event) {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault()
            $('nav.menu #open_menu_mobile ').trigger("click")
        }
    })

    $(document).on('keydown', function (event) {
        if (event.key === "Escape" && $nav.hasClass("isActive")) {
            $('nav.menu #open_menu_mobile ').trigger("click")
        }
    })


    $('nav.menu .sections .section1 li.off a').on('click', function (event) {
        event.preventDefault()
    })

    /**
    Rubriques à sous-pages : sans href (pages parentes redirigées), un clic / tap / Entrée ouvre le niveau 2.
    Indispensable sur mobile où le survol n'existe pas, utile au clavier et sur tablette en desktop.
     */
    $('<button type="button" class="retour">Retour</button>')
        .prependTo("nav.menu .sections .section2")
        .on('click', function () {
            $("nav.menu .sections .section2").removeClass("isActive")
        })

    $('nav.menu .sections .section1 a[data-cible]').on('click', function (event) {
        event.preventDefault()
        $("nav.menu .sections .section2 .active").removeClass("active")
        $("nav.menu .sections .section2 ." + $(this).data("cible")).addClass("active")
        $("nav.menu .sections .section2").addClass("isActive")
    }).on('keydown', function (event) {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault()
            $(this).trigger("click")
        }
    })

    /**
    DESKTOP : navigation au survol, niveau 2 puis visuel
     */
    $('nav.menu .sections .section1 a').on('mouseenter', function (event) {
        if (mobile.matches) return

        var cible = $(this).data("cible")

        $("nav.menu .sections .section2 .active").removeClass("active")
        if(cible){
            $("nav.menu .sections .section2 ."+cible).addClass("active")
            $("nav.menu .sections .section2").addClass("isActive")
        }else{
            $("nav.menu .sections .section2").removeClass("isActive")
        }
    })

    $('nav.menu .sections .section2 li a').on('mouseenter', function (event) {
        if (mobile.matches) return

        var cible = $(this).data("cible")
        $("nav.menu .sections .section3").addClass("isActive")
        $("nav.menu .sections .section3 .active").removeClass("active")

        $("nav.menu .sections .section3 ."+cible).addClass("active")
    })

    $('nav.menu .sections .section2').on( "mouseleave", function() {
        if (mobile.matches) return

        $("nav.menu .sections .section2").removeClass("isActive")
        $("nav.menu .sections .section3").removeClass("isActive")
    })

    // changement de mode (rotation tablette, redimensionnement) : on repart d'un menu fermé propre
    mobile.addEventListener("change", function () {
        if ($nav.hasClass("isActive")) {
            $('nav.menu #open_menu_mobile ').trigger("click")
        }
    })

});
